import { useApplicationStore } from '@/stores/application'

/**
 * Po prihlásení spáruje členský príspevok LEAF s účtom (podľa overeného e-mailu).
 *
 * Cieľ: všetci krúžkari na GROWNi. Platiteľ z Paysy, ktorý si založí účet,
 * má byť v admine Krúžkov prepojený hneď, nie až keď náhodou otvorí stránku
 * s príspevkom. Raz za reláciu a účet — je to jeden lacný dopyt.
 *
 * E-mail sa často overí až neskôr. Preto sa značka uloží len pri úspechu
 * alebo pri overenom e-maile; neoverený to skúsi znova pri ďalšom načítaní.
 */
const DONE_KEY = 'leaf-contribution-paired'

export default defineNuxtPlugin(() => {
    const applicationStore = useApplicationStore()
    const { authFetch } = useAuthFetch()

    watch(
        () => [applicationStore.userId, applicationStore.isEmailVerified] as const,
        async ([userId, verified]) => {
            if (!userId || verified === false) return
            try {
                if (sessionStorage.getItem(DONE_KEY) === userId) return
            } catch {
                // bez sessionStorage to skúsime pri každom načítaní — nevadí
            }
            try {
                await authFetch('/api/kruzky/contribution/pair', { method: 'POST' })
                try {
                    sessionStorage.setItem(DONE_KEY, userId)
                } catch {
                    // nič
                }
            } catch (error) {
                // Párovanie nie je kritické — stránka príspevku to spraví tiež.
                console.warn('[leaf-contribution-pair] Spárovanie zlyhalo:', error)
            }
        },
        { immediate: true }
    )
})
